import { APP_VERSION_URL } from './constants.js'
import { parseRemoteVersion } from './parse.js'

/** Fetches deployed version metadata. Never throws — returns null on failure. */
export async function fetchRemoteVersion() {
  try {
    const response = await fetch(APP_VERSION_URL, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
    if (!response.ok) return null
    const contentType = response.headers.get('content-type') || ''
    if (contentType.includes('text/html')) return null
    const text = await response.text()
    if (!text || text.trimStart().startsWith('<')) return null
    return parseRemoteVersion(JSON.parse(text))
  } catch {
    return null
  }
}
